const SCOPES = { ALL_ITEMS_RO: 'https://www.googleapis.com/auth/drive.readonly    https://www.googleapis.com/auth/analytics.readonly' };
const DEVELOPER_KEY = 'AIzaSyD1_WRrLuIoP-YelW4NRZv5Q6669Ksxkcg'; // 'AIzaSyDxqFEWkBmNUpnPRrPUbDEovIbAXdhpZJw';
const CLIENT_ID = '279203342315-d8n5l9lafa06eb3ajom0libkj6rq9dig.apps.googleusercontent.com';// '451967312150-rrq4p3qv4n1a9bji1v57tk9mnllmmr1r.apps.googleusercontent.com';


class GooglePicker {
  constructor(developerKey = DEVELOPER_KEY, clientId = CLIENT_ID, scope = SCOPES.ALL_ITEMS_RO) {
    // The Browser API key obtained from the Google API Console.
    this.developerKey = developerKey;

    // The Client ID obtained from the Google API Console. Replace with your own Client ID.
    this.clientId = clientId;

    this.scope = scope;

    this.pickerApiLoaded = false;
    this.clientApiLoaded = false;
    this.oauthToken = undefined;
    this.onPickSuccessCallback = undefined;

    this.onApiLoad();
  }


  pick({ success: onPickSuccess }) {
    if (this.oauthToken && this.pickerApiLoaded) {
      this.createPicker();
    } else if (this.clientApiLoaded) {
      this.GoogleAuth.signIn().then(() => {
        const user = this.GoogleAuth.currentUser.get();
        this.oauthToken = user.getAuthResponse().access_token;
        this.createPicker();
      });
    }

    this.onPickSuccessCallback = onPickSuccess;
  }

  // Use the API Loader script to load google.picker and gapi.auth.
  onApiLoad() {
    try {
      if (gapi) {
        gapi.load('client', () => this.onClientApiLoad());
        gapi.load('picker', () => this.onPickerApiLoad());
      }
    } catch (err) {
      console.log('Error invoking gapi (Google API)', err);
    }
  }


  onClientApiLoad() {
    try {
      const url = window.location;
      //   console.log("URL", url);
      if (!url.pathname.match('startup_statistics')) {
        gapi.client.init({ client_id: this.clientId, scope: this.scope }).then(() => {
          this.GoogleAuth = gapi.auth2.getAuthInstance();
          this.clientApiLoaded = true;
        });
      }
    } catch (err) {
      console.log('Error invoking gapi (Google API)', err);
    }
  }


  // onAuthApiLoad() {
  //     gapi.auth2.authorize({
  //         client_id: this.clientId,
  //         scope: this.scope
  //     }, (authResult) => this.handleAuthResult(authResult));
  // }

  onPickerApiLoad() {
    this.pickerApiLoaded = true;
    // this.createPicker();
  }

  handleAuthResult(authResult) {
    if (authResult && !authResult.error) {
      this.oauthToken = authResult.access_token;
      this.createPicker();
    }
  }

  // Create and render a Picker object for picking user Photos.
  createPicker() {
    if (this.pickerApiLoaded && this.oauthToken) {
      const picker = new google.picker.PickerBuilder()
        .addView(google.picker.ViewId.DOCS)
        .setOAuthToken(this.oauthToken)
        .setDeveloperKey(this.developerKey)
        .setCallback((data) => this.pickerCallback(data))
        .build();

      picker.setVisible(true);
    }
  }

  // A simple callback implementation.
  pickerCallback(data) {
    if (data[google.picker.Response.ACTION] === google.picker.Action.PICKED) {
      const docs = data[google.picker.Response.DOCUMENTS];
      const url = docs[0][google.picker.Document.URL];
      const name = docs[0][google.picker.Document.NAME];
      // const iconUrl = docs[0][google.picker.Document.ICON_URL];
      this.onPickSuccessCallback({ docs, url, name });
    }
  }
}

export default () => { } 